<template>
  <div>
    <van-skeleton title  :row="0" :loading="loading">
    <div class="vehicle-list" v-if="chetouList">
      <div class="vehicle-item" >
        <div class="vehicle-item-content" >

          <div class="bpm-status" v-if="chetouList.bpmStatus == 1">
            <van-tag type="danger">未提交</van-tag>
          </div>
          <div class="bpm-status" v-else-if="chetouList.bpmStatus == 2">
            <van-tag type="warning">待审核</van-tag>
          </div>
          <div class="bpm-status" v-else-if="chetouList.bpmStatus == 3">
            <van-tag type="primary">审核成功</van-tag>
          </div>

          <div class="info-title">车头号：{{chetouList.chetouhao}}</div>
          <div class="info-info-title-2" v-if="chetouList.sscd>0">所属车队：{{chetouList.sscd}}</div>
          <div class="info-info-title-2">总质量：{{chetouList.zongzhiliang?chetouList.zongzhiliang:0}}KG</div>
          <div class="info-info-title-2">整备质量：{{chetouList.zhengbeizhiliang?chetouList.zhengbeizhiliang:0}}KG</div>
          <div class="info-info-title-2">行驶证有效期：{{chetouList.xingshizhengyxq}}</div>
        </div>

      </div>
    </div>
    <div v-else>
      <van-empty description="您尚未绑定车辆，请先搜索车辆">
        <div class="btns-box">
          <div class="search-btn-box">
            <van-button round type="danger" block class="bottom-button" @click="steamSearchChetouVehicle">搜  索  车  辆</van-button>
          </div>
          <div class="padding-box"></div>
          <div class="add-btn-box">
            <van-button round type="default" block class="bottom-button" @click="addChetouVehicle">未找到，新增车辆</van-button>
          </div>
        </div>
      </van-empty>
    </div>
    </van-skeleton>
  </div>
</template>
<script>
import api from '@/fetch/api';
import { Toast } from 'vant';

export default {
  data(){
    return {
      chetouList:[],
      loading:true,
    };
  },
  methods:{
    getChetouList(openid) {
      var that = this;
      api.getChetouList(openid).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          that.chetouList = resData.data;
          that.loading = false;
          if(that.chetouList && that.chetouList.bpmStatus == "3")
          {
            that.$emit("update-props",true);
            that.$emit("update-info",'chetouhao',that.chetouList);
          }
          else{
            that.$emit("update-props",false);
          }
        }
      }).catch(function() {
        Toast.fail('连接失败，请刷新页面');
      });
    },
    //搜索车辆
    steamSearchChetouVehicle()
    {
      this.$router.push({
        name: 'addAllCar'
      })
    },
    addChetouVehicle()
    {
      this.$router.push({
        name: 'addchetou'
      })
    },
  },
  created(){
    var openid = this.$store.state.wx_info.openid;
    this.getChetouList(openid);
    this.$emit("update-props",false);
  },
}
</script>
<style lang="scss">
.vehicle-list {
    margin-bottom: 4.75rem;
    .vehicle-item {
        margin: 1rem 1rem 0;
        overflow: hidden;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 0 4px rgba(0, 0, 0, .1);
        .vehicle-item-content {
            align-items: center;
            box-sizing: border-box;
            min-height: 84px;
            padding: 1rem;
            color: #323233;
            .info-title {
                font-weight: bold;
                font-size: 1rem;
                line-height: 1.5;
            }
            .info-info-title-2 {
                line-height: 1.5;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 0.875rem;
            }
        }
        .vehicle-item-desc {
            padding: 1rem;
            font-size: 0.875rem;
            border-top: 1px dashed #ebedf0;
        }
    }
}
.bpm-status {
    float: right;
}

.padding-box{
  height: 1rem;
}
</style>
